<template>
	<!-- 收到评论 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">收到评论</p>
				</div>
			</div>
		</van-sticky>
		<div class="qjylBoxNum"  v-if="showBox">
			<div class="qjylNum" @click="jumpUrlplsx(item)" v-for="(item,index) in commentList">
				<span>{{item.books_name}}</span>
				<span class="plNum"><i>{{item.count}}</i><span>条新评论</span><img src="../../assets/img/rightArr.png" alt=""></span>
			</div>
		</div>
		<div v-if="!showBox" class="zwsjToast">
			<img src="../../assets/img/data_null.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				commentList:[],
				showBox: false,
			}
		},
		created() {
			this.comment_list()
		},
		methods: {
			jumpUrlplsx(item){
				this.$router.push({path:'/plsx',query:{books_id: item.books_id,txt:item.books_name}})
			},
			back() {
				this.$router.push('/userinfo')
			},
			comment_list(){
				this.$axios.post(this.$api.comment_list).then(res => {
					this.commentList = res.data.data;
					if(this.commentList.length){
						this.showBox = true;
					}else{
						this.showBox = false;
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.qjylBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		.zwsjToast{
			text-align: center;
			position: fixed;
			top: 40%;
			left: 50%;
			transform: translate(-50%,-40%);
			img{
				width: 160px;
			}
		}
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.qjylBoxNum {
			padding: 0 16px;
			background-color: #fff;
			padding-top: 30px;
			//我的琼浆玉露
			.qjylNum {
				margin-bottom: 20px;
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				line-height: 80px;
				padding: 20px 30px;
				display: flex;
				font-weight: 400;
				color: #000000;
				font-size: 30px;/*px*/
				span{
					flex: 1;
				}
				span:last-child{
					text-align: right;
					i{
						color: #ff4081;
						font-style: normal;
						margin-right: 10px;
					}
					img{
						width: 50px;
						vertical-align: middle;
					}
				}
			}
		}
		
	}

</style>
